const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const formActions = require('react-redux-form').actions;
const { ProfessionFinder } = require('components/professionTypes/professionFinder');
const PropTypes = require('prop-types');

class Cno extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { handleSave, disabled, onFieldChange, onActivityChange } = this.props;
        return (
            <ProfessionFinder
                handleSave={handleSave}
                disabled={disabled}
                onFieldChange={onFieldChange}
                onActivityChange={onActivityChange}
            />
        );
    }
}

Cno.propTypes = {
    userProfile: PropTypes.object.isRequired,
};

module.exports.constructor = Cno;
module.exports.Cno = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        options: state.options,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
    })
)(Cno);
